import snakeCase from 'lodash/snakeCase';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';

function toSnakeCase(object) {
  return Object.keys(object).reduce((newObj, key) => {
    const value = object[key];
    const isPureObject = isObject(value) && !isArray(value);

    return {
      ...newObj,
      [snakeCase(key)]: isPureObject ? toSnakeCase(value) : value,
    };
  }, {});
}

export default toSnakeCase;



// WEBPACK FOOTER //
// ./src/utils/snakecaseKeys.js